'use strict'

export default [
  {
    name: "issueRegister",
    hideButtons: true
  },
  {
    name: "changeControlApproach",
    fields: [
      { name: "process", height:5 },
      { name: "tools", height: 3 },
      { name: "reporting", height: 2 },
      { name: "timing", height:3 },
      { name: "roles", height: 3 },
      { name: "scales", height: 2 }
    ]
  }
]



// WEBPACK FOOTER //
// ./views/change/changeControlApproachFormDefinition.js